// Global handler for data-confirm
// Usage: <button data-confirm="Are you sure?">Delete</button>

export function initConfirmation(): void {
  document.addEventListener("click", (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const trigger = target.closest("[data-confirm]") as HTMLElement | null;

    if (trigger) {
      const message = trigger.getAttribute("data-confirm");
      if (message && !confirm(message)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", initConfirmation);
